import { Award, BookOpen, Clock, User } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import './OurTeam.css';

const OurTeam = () => {
  const whatsappUrl = 'https://wa.me/919886332528';

  const team = [
    {
      role: 'Lead Physiotherapist',
      qualification: 'BPT, MSc Physiotherapy',
      specialization: 'Orthopaedic & Sports',
      experience: '8+ Years Experience',
      avatar: 'https://images.unsplash.com/photo-1649751361457-01d3a696c7e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwaHlzaW90aGVyYXB5JTIwdHJlYXRtZW50fGVufDB8fHx8MTc4MDQ3NjIxMnww&ixlib=rb-4.1.0&q=85'
    },
    {
      role: 'Senior Rehab Specialist',
      qualification: 'BPT Certified',
      specialization: 'Neuro & Post-Surgical Rehab',
      experience: '6+ Years Experience',
      avatar: 'https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxwaHlzaW90aGVyYXB5JTIwdHJlYXRtZW50fGVufDB8fHx8MTc4MDQ3NjIxMnww&ixlib=rb-4.1.0&q=85'
    },
    {
      role: 'Home Visit Specialist',
      qualification: 'BPT Certified',
      specialization: 'Orthopaedic & Elderly Care',
      experience: '5+ Years Experience',
      avatar: 'https://images.pexels.com/photos/20860625/pexels-photo-20860625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    },
    {
      role: 'Paediatric Physiotherapist',
      qualification: 'BPT, Paediatric Certification',
      specialization: 'Child Rehabilitation',
      experience: '4+ Years Experience',
      avatar: 'https://images.pexels.com/photos/30483049/pexels-photo-30483049.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    },
    {
      role: 'Exercise & Rehab Therapist',
      qualification: 'BPT Certified',
      specialization: 'Strength & Mobility Rehab',
      experience: '3+ Years Experience',
      avatar: 'https://images.unsplash.com/photo-1645005513713-9e2b92a687d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxwaHlzaW90aGVyYXB5JTIwdHJlYXRtZW50fGVufDB8fHx8MTc4MDQ3NjIxMnww&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <div className="team-page">
      <div className="page-hero">
        <div className="container">
          <h1>A Skilled Team. One Trusted Clinic.</h1>
          <p className="page-subtitle">
            Dr. Manaz's clinic houses Panjim's largest team of certified physiotherapists — each specialising in a different area so you always receive expert, focused care.
          </p>
        </div>
      </div>

      {/* Stats Banner */}
      <section className="stats-banner">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <User size={32} />
              <h3>5+</h3>
              <p>Certified Physiotherapists</p>
            </div>
            <div className="stat-item">
              <Clock size={32} />
              <h3>20+</h3>
              <p>Years Combined Experience</p>
            </div>
            <div className="stat-item">
              <Award size={32} />
              <h3>100%</h3>
              <p>BPT Qualified Team</p>
            </div>
            <div className="stat-item">
              <BookOpen size={32} />
              <h3>Multiple</h3>
              <p>Specialized Areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Cards */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Meet Our Expert Team</h2>
            <p>Specialized physiotherapists for every condition</p>
          </div>
          <div className="team-grid">
            {team.map((member, index) => (
              <Card key={index} className="team-card">
                <div className="team-avatar-wrapper">
                  <div className="team-avatar">
                    <img src={member.avatar} alt={member.role} />
                  </div>
                </div>
                <CardContent className="team-content">
                  <h3>{member.role}</h3>
                  <div className="team-details">
                    <div className="detail-badge">
                      <Award size={16} />
                      <span>{member.qualification}</span>
                    </div>
                    <div className="detail-badge">
                      <BookOpen size={16} />
                      <span>{member.specialization}</span>
                    </div>
                    <div className="detail-badge experience">
                      <Clock size={16} />
                      <span>{member.experience}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="team-closing">
            <p>
              Every patient at Dr. Manaz's clinic is treated by a qualified, experienced physiotherapist. Your recovery is in expert hands.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-dark cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Experience Expert Care from Our Team</h2>
            <p>Book your appointment and meet the physiotherapist who can help you best</p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary large">
              Book Appointment on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurTeam;